import { useEffect, useState } from "react";
import { RotateCcw, Search } from "lucide-react";
import { api } from "../../api";
import { Filters } from "../../shell";

const emptyFilters = { org_node_id: "", seller_id: "", insurance_company_id: "", policy_group_id: "", branch_name: "", canonical_customer_id: "" };

export function PortfolioFilters({ dataset, periodProps, filters, setFilters }) {
  const [options, setOptions] = useState(null);
  const [optionError, setOptionError] = useState(false);
  const [customerQuery, setCustomerQuery] = useState("");
  const [customers, setCustomers] = useState([]);
  const [customerError, setCustomerError] = useState(false);
  useEffect(() => { api.get("/portfolio/options").then((response) => setOptions(response.data)).catch(() => setOptionError(true)); }, []);
  useEffect(() => {
    if (customerQuery.trim().length < 2) { setCustomers([]); return; }
    const timer = setTimeout(() => { setCustomerError(false); api.get("/portfolio/customer-options", { params: { search: customerQuery } })
      .then((response) => setCustomers(response.data.items || []))
      .catch(() => { setCustomers([]); setCustomerError(true); }); }, 250);
    return () => clearTimeout(timer);
  }, [customerQuery]);
  const update = (key, value) => setFilters({ ...filters, [key]: value });
  return <>
    <Filters {...periodProps} isDemo={dataset?.state?.active === "DEMO"} />
    <div className="portfolio-dimension-filters" data-testid="portfolio-filter-bar">
      {optionError && <div data-testid="portfolio-options-error" className="portfolio-filter-error">Filtre seçenekleri alınamadı.</div>}
      <label>Organizasyon
        <select data-testid="filter-region-org-select" value={filters.org_node_id} onChange={(event) => update("org_node_id", event.target.value)}>
          <option value="">Tüm organizasyon</option>
          {(options?.org_nodes || []).map((node) => <option key={node.id} value={node.id}>{node.path || node.node_name}</option>)}
        </select>
      </label>
      <label>Satıcı
        <select data-testid="filter-seller-select" value={filters.seller_id} onChange={(event) => update("seller_id", event.target.value)}>
          <option value="">Tüm satıcılar</option>
          {(options?.sellers || []).map((item) => <option key={item.id} value={item.id}>{item.name}</option>)}
        </select>
      </label>
      <label>Sigorta Şirketi
        <select data-testid="filter-insurer-select" value={filters.insurance_company_id} onChange={(event) => update("insurance_company_id", event.target.value)}>
          <option value="">Tüm şirketler</option>
          {(options?.companies || []).map((item) => <option key={item.id} value={item.id}>{item.name}</option>)}
        </select>
      </label>
      <label>Poliçe Grubu
        <select data-testid="filter-policy-group-select" value={filters.policy_group_id} onChange={(event) => update("policy_group_id", event.target.value)}>
          <option value="">Tüm gruplar</option>
          {(options?.policy_groups || []).map((item) => <option key={item.id} value={item.id}>{item.name}</option>)}
        </select>
      </label>
      <label>Branş
        <select data-testid="filter-branch-select" value={filters.branch_name} onChange={(event) => update("branch_name", event.target.value)}>
          <option value="">Tüm branşlar</option>
          {(options?.branches || []).map((name) => <option key={name} value={name}>{name}</option>)}
        </select>
      </label>
      <label className="portfolio-customer-search">Kanonik Müşteri
        <span><Search size={13}/><input data-testid="filter-canonical-customer-input" value={customerQuery}
          placeholder="Müşteri ara" onChange={(event) => setCustomerQuery(event.target.value)} /></span>
        {customers.length > 0 && <select data-testid="filter-canonical-customer-results" value={filters.canonical_customer_id}
          onChange={(event) => update("canonical_customer_id", event.target.value)}>
          <option value="">Sonuç seçin</option>
          {customers.map((customer) => <option key={customer.id} value={customer.id}>{customer.canonical_name}</option>)}
        </select>}
        {customerError && <small data-testid="portfolio-customer-search-error">Müşteri araması alınamadı.</small>}
      </label>
      <button data-testid="clear-all-filters-btn" className="portfolio-clear-button" onClick={() => { setFilters(emptyFilters); setCustomerQuery(""); }}>
        <RotateCcw size={14}/> Temizle
      </button>
    </div>
  </>;
}

export { emptyFilters };